// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"a7e9f916","62":"c221a636","122":"2b0f29a1","123":"ee7519f8","593":"ba0b4ed0","619":"6798e3c3","675":"e8c3df02","976":"864eb97c"}[chunkId] + ".chunk.js";
};